import * as XLSX from 'xlsx';

function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

export function exportRowsToCsv(rows, fileName) {
  const worksheet = XLSX.utils.json_to_sheet(rows || []);
  const csv = XLSX.utils.sheet_to_csv(worksheet);
  downloadBlob(new Blob([csv], { type: 'text/csv;charset=utf-8;' }), fileName);
}

export function exportSheetsToXlsx(sheets, fileName) {
  const workbook = XLSX.utils.book_new();
  Object.entries(sheets).forEach(([sheetName, rows]) => {
    const worksheet = XLSX.utils.json_to_sheet(rows || []);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31));
  });
  XLSX.writeFile(workbook, fileName);
}

function pushRows(rows, section, items, labelKey = 'label', valueKey = 'project_count') {
  (items || []).forEach((item) => rows.push({
    section,
    label: item[labelKey],
    value: item[valueKey],
    ...item,
  }));
}

export function flattenDashboardSummary(summary) {
  if (!summary) return [];
  const rows = [];
  (summary.kpis || []).forEach((item) => rows.push({ section: 'KPI', label: item.label, value: item.value }));
  pushRows(rows, 'Milestone Summary', summary.milestoneSummary, 'milestone_type');
  pushRows(rows, 'Projects Delivered by Service', summary.serviceSummary, 'service_type');
  pushRows(rows, 'Initial Project Delivery by Service', summary.initialByService, 'service_type');
  pushRows(rows, 'Restamp Required by Service', summary.reworkByService, 'service_type');
  pushRows(rows, 'Initial On-Time Status', summary.initialOnTimeStatus, 'status');
  pushRows(rows, 'Restamp On-Time Status', summary.reworkOnTimeStatus, 'status');
  pushRows(rows, 'Initial On-Time by Service', summary.initialOnTimeByService, 'service_type');
  pushRows(rows, 'Restamp On-Time by Service', summary.reworkOnTimeByService, 'service_type');
  pushRows(rows, 'Internal Design Quality by Milestone', summary.designQualityByMilestone, 'milestone_type', 'no_error_percent');
  pushRows(rows, 'Average Idle Time', summary.idleTimeSummary, 'milestone_type', 'request_count');
  pushRows(rows, 'In House vs External', summary.inHouseExternalSummary, 'in_house_vs_external', 'initial_project_delivery');
  pushRows(rows, 'Average On-Hold by Reason', summary.avgOnHoldByReason, 'reason', 'avg_on_hold_time');
  pushRows(rows, 'CRE Restamp Reason Summary', summary.creRestampReasonSummary, 'reason');
  pushRows(rows, 'On-Hold Reason Summary', summary.onHoldReasonSummary, 'reason');
  return rows;
}
